export const NewsSwimmerConstants = {
    newsSwimmerClass: ".news_swimmer",
    newsButtonCloseClass: ".news_swimmer-close-wrapper",
    newsSwimmerWrapperClass: ".news_swimmer-wrapper",
    newsSwimmerCollapsedClass: ".news_swimmer-collapsed",
    newsSwimmerArrowSvg: ".news_swimmer-collapsed svg",
    newsSwimmerStep2Close: ".step-2-close-wrapper",
};
